<div class="container">
    <h3 mat-dialog-title>Czy chcesz usunąć {{data.name}}?</h3>
    <div mat-dialog-actions>
      <button mat-button [mat-dialog-close]="1" (click)="confirmDelete()">Usuń</button>
      <button mat-button (click)="onNoClick()" tabindex="-1">Anuluj</button>
    </div>
  </div>
